import { splitTxtValue } from "./useHook";

const formatHeader = (headerArr: string[]) => {
  const result: any = {};
  const header = headerArr[0];
  //データ区分　1桁　1:ヘッダ
  result["dataDivision"] = header.substring(0, 1);
  //種別コード　2桁　業務種別を表わす　01:振込入金通知
  result["typeCode"] = header.substring(1, 3);
  //コード区分　1桁　使用コードの区分を表わす　0:JIS　1:EBCDIC
  result["codeDivision"] = header.substring(3, 4);
  //作成日　6桁　作成日を表わす　YYMMDD
  result["startUpDate"] = header.substring(4, 10);
  //勘定日(自)　6桁　勘定日(自)を表わす　YYMMDD
  result["accountDateFrom"] = header.substring(10, 16);
  //勘定日(至)　6桁　勘定日(至)を表わす　YYMMDD
  result["accountDateTo"] = header.substring(16, 22);
  //銀行コード　4桁　統一金融機関番号
  result["bankNumber"] = header.substring(22, 26);
  //銀行名　15桁　銀行名 左詰め残りスペース
  result["bankName"] = header.substring(26, 41).trim().padEnd(15, " ");
  //支店コード　3桁　統一店番号
  result["branchNumber"] = header.substring(41, 44);
  //支店名　15桁　支店名 左詰め残りスペース
  result["branchName"] = header.substring(44, 59).trim().padEnd(15, " ");
  //預金種目　1桁　0:普通 1:当座 2:貯蓄
  result["depositType"] = header.substring(59, 60);
  //口座番号　7桁　口座番号
  result["accountNumber"] = header.substring(60, 67).padStart(7, "0");
  //口座名　40桁　口座名 左詰め残りスペース
  result["accountName"] = header.substring(67, 107).trim();
  //ダミー　93桁　ダミー
  result["dummy"] = header.substring(107, 200).trim();
  return result;
};

const formatData = (recordArr: string[]) => {
  const result: any = {};
  const record = recordArr[0];
  // データ区分 1桁 2:データ
  result["dataDivision"] = record.substring(0, 1);
  // 照会番号 6桁 銀行が採番した照会用番号　右詰め残り前「0」
  result["inquiryNumber"] = record
    .substring(1, 7)
    .replace(/^0+/, "")
    .padStart(6, "0");
  // 勘定日 6桁　YYMMDD
  result["accountDate"] = record.substring(7, 13);
  // 起算日 6桁　YYMMDD
  result["startUpDate"] =
    parseInt(record.substring(13, 15), 10) +
    2018 +
    "/" +
    record.substring(15, 17) +
    "/" +
    record.substring(17, 19);

  // 金額 10桁　右詰め残り前「0」
  result["amount"] = record
    .substring(19, 29)
    .replace(/^0+/, "")
    .padStart(10, "0");
  // うち他店券金額 10桁　右詰め残り前「0」
  result["otherStoreAmount"] = record
    .substring(29, 39)
    .replace(/^0+/, "")
    .padStart(10, "0");
  // 振込依頼人コード 10桁　右詰め残り前「0」
  result["transferRequesterCode"] = record
    .substring(39, 49)
    .replace(/^0+/, "")
    .padStart(10, "0");
  // 振込依頼人名 48桁　左詰め残りスペース
  result["transferRequesterName"] = record.substring(49, 97).trim();
  // 仕向銀行名 15桁　左詰め残りスペース
  result["destinationBankName"] = record
    .substring(97, 112)
    .trim()
    .padEnd(15, " ");
  // 仕向店名 15桁　左詰め残りスペース
  result["destinationBranchName"] = record
    .substring(112, 127)
    .trim()
    .padEnd(15, " ");
  // 取消区分 1桁　1:取消
  result["cancelType"] = record.substring(127, 128);
  // EDI情報 20桁　左詰め残りスペース
  result["ediInformation"] = record.substring(128, 148).trim();
  // ダミー 52桁　スペースとする
  result["dummy"] = record.substring(148, 200).trim();
  return result;
};

const formatTrailer = (trailerArr: string[]) => {
  const result: any = {};
  const trailer = trailerArr[0];

  result["dataDivision"] = trailer.substring(0, 1);
  result["totalNumber"] = trailer.substring(1, 7).replace(/^0+/, "");
  result["totalAmount"] = trailer.substring(7, 19).replace(/^0+/, "");
  result["cancelTotalNumber"] = trailer.substring(19, 25).replace(/^0+/, "");
  result["cancelTotalAmount"] = trailer.substring(25, 37).replace(/^0+/, "");
  result["dummy"] = trailer.substring(37, 200).trim();
  return result;
};

const formatEnd = (endArr: string[]) => {
  const result: any = {};
  const end = endArr[0];
  result["dataDivision"] = end.substring(0, 1);
  result["dummy"] = end.substring(1, 200).trim();
  return result;
};

const transferResultFormat = (txtValue: any) => {
  const result: any = {};
  const { header, data, trailer, end } = splitTxtValue(txtValue);

  result["header"] = formatHeader(header);
  result["data"] = data.map((record: any) => formatData(record));
  result["trailer"] = formatTrailer(trailer);
  result["end"] = formatEnd(end);

  return result;
};

export { transferResultFormat, formatData as transferResultData };
